module.exports = __webpack_public_path__ + "img/corona-1-welle.9833f77a.png";